import * as a_recaptcha from './a_recaptcha';

/**
 * @param {HTMLFormElement} form
 * @param {HTMLElement} submit
 */
export default function recaptchaManagedForm(form, submit) {
  let waiting = false;
  const listener = (e) => {
    e.preventDefault();

    if (waiting) return;
    waiting = true;

    a_recaptcha
      .load()
      .then(() => {
        a_recaptcha.register(submit, () => form.submit());
        a_recaptcha.execute(submit);
      })
      .then(() => (waiting = false));
  };

  form.addEventListener('submit', listener);

  a_recaptcha
    .load()
    .then(() => {
      // this is so a badge will be rendered at the right time
      const div = document.createElement('div');
      form.parentElement.appendChild(div);
      a_recaptcha.register(div, () => {});
      a_recaptcha.moveBadgeWhenVisible(form);
    })
    .catch(
      () => form.removeEventListener('submit', listener), // captcha doesn't work abort
    );
}
